import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntitySitiosProcesamientoState
} from './sitios-procesamiento.state';
import { entitySitiosProcesamientoAdapter } from './sitios-procesamiento.state';
import {
  entitySitiosProcesamientoLoadRequest,
  entitySitiosProcesamientoLoadSuccess,
  entitySitiosProcesamientoLoadFailure,
  entitySitiosProcesamientoAddFailure,
  entitySitiosProcesamientoAddRequest,
  entitySitiosProcesamientoAddSuccess,
  entitySitiosProcesamientoDeleteSuccess,
  entitySitiosProcesamientoDeleteRequest,
  entitySitiosProcesamientoDeleteFailure
} from './sitios-procesamiento.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entitySitiosProcesamientoLoadRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entitySitiosProcesamientoLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entitySitiosProcesamientoLoadSuccess, (state, { items }) =>
    entitySitiosProcesamientoAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entitySitiosProcesamientoAddRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),
  on(entitySitiosProcesamientoAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entitySitiosProcesamientoAddSuccess, (state, { item }) => {
    return entitySitiosProcesamientoAdapter.upsertMany(item, {
      ...state,
      hasAddedSuccess: true,
      isLoading: false,
      error: null
    });
  }),
  //delete

  on(entitySitiosProcesamientoDeleteRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null
  })),

  on(entitySitiosProcesamientoDeleteFailure, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  })),

  on(entitySitiosProcesamientoDeleteSuccess, (state, { item }) =>
    entitySitiosProcesamientoAdapter.removeOne(item.id, {
      ...state,
      isLoading: false
    })
  )
);

export function sitiosProcesamientoReducer(
  state: EntitySitiosProcesamientoState | undefined,
  action: Action
) {
  return reducer(state, action);
}
